/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmployeesMercerStandingsMercerStandingValidationStateModel {
  validationState?: EmployeesMercerStandingsMercerStandingValidationStateModelValidationStateEnum;
  lastAcknowledgedAt?: string | null;
}
export enum EmployeesMercerStandingsMercerStandingValidationStateModelValidationStateEnum {
  Open = 'Open',
  RequestedHr = 'RequestedHR',
  RequestedCb = 'RequestedCB',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
